// extracted by mini-css-extract-plugin
export var backgroundImage = "_x-1";
export var container = "_x-0";
export var title = "_x-2";